
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/terms/[slug]",
      function () {
        return require("private-next-pages/en/terms/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/terms/[slug]"])
      });
    }
  